import api from './api';

export const sportsApi = {
  /** Returns metadata array for all supported sports */
  getAll: () => api.get('/api/sports'),

  /** Returns full metadata/config for a specific sport */
  getConfig: (sport) => api.get(`/api/sports/${sport}/config`)
};
